
import angular from 'angular';

angular.module('folkeuni').factory('MailchimpApi', function($http) {
  var self = this;
  var apiBase = '/api/mailchimp/';

    self.subscribe = function (despartmentId, subscriberObj) {
      return $http({
          method: 'post',
          data: subscriberObj,
          url: apiBase + despartmentId + '/subscribe'
      });
  };

    self.getSubscriber = function (departmentId, email) {
      return $http({
          method: 'get',
          url: apiBase + departmentId + '/subscriber?email=' + email
      });
  };
  
  return self;
});
